// extracted by mini-css-extract-plugin
export default {"FilterContainerStyle":"table-filter-input_FilterContainerStyle__UzLPK","InputTextStyle":"table-filter-input_InputTextStyle__cfMlU"};